import { red } from "@material-ui/core/colors"
import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  typography: {
    subtitle1: {
      color: "#2972B9",
    },
  },
  palette: {
    type: "light",
    primary: {
      main: "#1255A4",

    },
    secondary: {
      main: "#2972B9",
    },
    info: {
      main: "#51015C",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#69A6DA",
      secondary: "#69A6DA",
      disabled: "#CCC",
      hint: "#7D7987",
    },
  },
  shape: {
    borderRadius: 20,
  },
})

export default theme
